import React from 'react'
import { MenuList, MenuItem } from '@mui/material'
import { Link } from 'react-router-dom'
import {  MENU_SIDEBAR_OPTIONS } from '../../helpers/options/options'
import { useTranslation } from 'react-i18next'
import { logOut } from '../../helpers/utils'

const MenuLogged = () => {
  const { t } = useTranslation()
 

  return (
    <>
      <MenuList className='menu-logged'>
        {MENU_SIDEBAR_OPTIONS.map((value, index) => {
          return (
            <MenuItem
              id={`MenuItem-${index}-circle`}
              key={`MenuItem-${index}`}
              className='menu-logged-size'
              component={Link}
              to={`${value.to}`}
            >
              {`${t(value.label)}`}
            </MenuItem>
          )
        })}

        <hr className='my-1' />

        <MenuItem
          disabled
          id={`MenuItem-help-circle`}
          className='menu-logged-size'
          component={Link}
          to='/help'
        >{`${t('HELP')}`}</MenuItem>
        <MenuItem
          id={`MenuItem-close-circle`}
          className='menu-logged-size'
          onClick={() => logOut()}
        >
          {`${t('LOGOUT')}`}
        </MenuItem>
      </MenuList>
    </>
  )
}

export default MenuLogged
